

.rowContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1;
  min-width: 0;
}

.productImageContainer {
  position: relative;
}

.productImageQuantity {
  position: absolute;
  right: 0;
  bottom: -0.6em;
  background: var(--static-background-strong);
  border: 1px solid;
  padding: 0 7px;
  font-weight: var(--font-weight-strong);
  border-radius: 10000px;
  min-width: 1.6em;
  text-align: center;
}
.productImageQuantity.small {
  bottom: -0.8em;
  font-size: var(--fs-x-small);
}

.productDetailsContainer {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.productDetailContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  width: 100%;
}

.productNameRow {
  display: flex;
  gap: 3px;
  align-self: stretch;
}
